// extracted by mini-css-extract-plugin
export default {"headerContainer":"OptionRoyaltyRestrictionDetails_headerContainer__T6h9B","headerLeft":"OptionRoyaltyRestrictionDetails_headerLeft__1ge2I"};